// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"779":"a1e7b8a2","6534":"ce99d352"}[chunkId] + ".chunk.css";
};